module.exports = __webpack_public_path__ + "static/media/speedometer-grey.f7990b50.svg";